import { render, staticRenderFns } from "./MvpFeedbackBar.vue?vue&type=template&id=58641aca&scoped=true&"
import script from "./MvpFeedbackBar.vue?vue&type=script&lang=js&"
export * from "./MvpFeedbackBar.vue?vue&type=script&lang=js&"
import style0 from "./MvpFeedbackBar.vue?vue&type=style&index=0&id=58641aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58641aca",
  null
  
)

export default component.exports